module.exports = __webpack_public_path__ + "static/media/auto-play-on.4519cd0c.svg";